import React from 'react';

function RegulaminPage() {
  return (
    <div style={{ 
      maxWidth: '900px',
      margin: '4rem auto',
      padding: '2rem',
      textAlign: 'left',
      lineHeight: '1.7',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div className="flex justify-center items-center gap-4 mb-6">
        <div className="w-16 h-16 rounded-2xl flex items-center justify-center bg-gradient-to-r from-purple-500 to-purple-700 shadow-lg">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
          </svg>
        </div>
        <h1 className="text-4xl md:text-5xl font-extrabold text-white">Regulamin KrukShop</h1>
      </div>

      <section className="container mx-auto max-w-4xl px-4 md:px-6 space-y-8">
        <article className="bg-white/5 p-6 md:p-8 rounded-2xl backdrop-blur-lg border border-white/10">
          <h2 className="text-xl md:text-2xl font-bold text-blue-400 mb-4">§1. Postanowienia ogólne</h2>
          <p className="text-gray-300 leading-relaxed whitespace-pre-line">
            KrukShop to platforma umożliwiająca tworzenie własnych sklepów i sprzedaż przedmiotów cyfrowych. 
            Korzystanie z serwisu oznacza akceptację regulaminu i polityki prywatności.
          </p>
        </article>

        <article className="bg-white/5 p-6 md:p-8 rounded-2xl backdrop-blur-lg border border-white/10">
          <h2 className="text-xl md:text-2xl font-bold text-blue-400 mb-4">§2. Rejestracja i konto</h2>
          <p className="text-gray-300 leading-relaxed whitespace-pre-line">
            1. Aby korzystać z KrukShop, użytkownik musi zarejestrować konto i podać prawdziwe dane.  
            2. Każdy właściciel sklepu jest odpowiedzialny za bezpieczeństwo swojego konta.  
            3. Zabronione jest tworzenie kont w celu oszustwa lub naruszenia zasad platformy.
          </p>
        </article>

        <article className="bg-white/5 p-6 md:p-8 rounded-2xl backdrop-blur-lg border border-white/10">
          <h2 className="text-xl md:text-2xl font-bold text-blue-400 mb-4">§3. Tworzenie własnego sklepu</h2>
          <p className="text-gray-300 leading-relaxed whitespace-pre-line">
            1. Każdy użytkownik może utworzyć własny sklep w KrukShop.  
            2. Właściciel sklepu odpowiada za treści, ceny, opisy produktów oraz przestrzeganie prawa.  
            3. Zakazane jest oferowanie produktów nielegalnych, wprowadzających w błąd lub naruszających prawa osób trzecich.  
            4. KrukShop może w każdej chwili zablokować sklep w przypadku naruszenia regulaminu.
          </p>
        </article>

        <article className="bg-white/5 p-6 md:p-8 rounded-2xl backdrop-blur-lg border border-white/10">
          <h2 className="text-xl md:text-2xl font-bold text-blue-400 mb-4">§4. Płatności i prowizje</h2>
          <p className="text-gray-300 leading-relaxed whitespace-pre-line">
            1. Wszystkie transakcje realizowane są za pośrednictwem systemów płatności dostępnych na platformie.  
            2. KrukShop pobiera prowizję od każdej sprzedaży zgodnie z obowiązującymi stawkami.  
            3. Właściciel sklepu zobowiązany jest do prawidłowego rozliczania się z podatków wynikających z działalności.
          </p>
        </article>

        <article className="bg-white/5 p-6 md:p-8 rounded-2xl backdrop-blur-lg border border-white/10">
          <h2 className="text-xl md:text-2xl font-bold text-blue-400 mb-4">§5. Reklamacje i zwroty</h2>
          <p className="text-gray-300 leading-relaxed whitespace-pre-line">
            1. Właściciel sklepu odpowiada za obsługę reklamacji klientów zgodnie z obowiązującym prawem.  
            2. Ze względu na charakter produktów cyfrowych, zwroty mogą być ograniczone.  
            3. KrukShop pośredniczy w rozwiązywaniu sporów, ale nie ponosi odpowiedzialności za błędy właścicieli sklepów.
          </p>
        </article>

        <article className="bg-white/5 p-6 md:p-8 rounded-2xl backdrop-blur-lg border border-white/10">
          <h2 className="text-xl md:text-2xl font-bold text-blue-400 mb-4">§6. Odpowiedzialność i bezpieczeństwo</h2>
          <p className="text-gray-300 leading-relaxed whitespace-pre-line">
            1. KrukShop nie odpowiada za treści ani działania właścicieli sklepów.  
            2. Platforma stosuje środki techniczne w celu ochrony danych i bezpieczeństwa transakcji, ale nie gwarantuje pełnej ochrony przed nadużyciami.  
            3. W przypadku wykrycia naruszeń, KrukShop zastrzega sobie prawo do blokady konta lub sklepu.
          </p>
        </article>

        <article className="bg-white/5 p-6 md:p-8 rounded-2xl backdrop-blur-lg border border-white/10">
          <h2 className="text-xl md:text-2xl font-bold text-blue-400 mb-4">§7. Postanowienia końcowe</h2>
          <p className="text-gray-300 leading-relaxed whitespace-pre-line">
            1. KrukShop zastrzega sobie prawo do zmiany regulaminu w dowolnym czasie.  
            2. Aktualna wersja regulaminu jest zawsze dostępna na stronie platformy.  
            3. Korzystanie z platformy po zmianach regulaminu oznacza akceptację nowych warunków.
          </p>
        </article>

        <div className="bg-white/5 p-6 rounded-2xl text-center backdrop-blur-lg border border-white/10">
          <p className="text-gray-400 flex items-center justify-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
            </svg>
            Data ostatniej aktualizacji: 15.12.2025
          </p>
        </div>
      </section>
    </div>
  );
}

export default RegulaminPage;